import {useContext, useEffect, useState} from 'react'

import {Button, Center} from '@mantine/core'
import {Modal} from 'react-bootstrap'
import {
  changeTextCapital,
  checkRole,
  sortEmailsDescending,
} from '../../../_metronic/helpers/AssetHelpers'
import {Toolbar1} from '../../../_metronic/layout/components/toolbar/Toolbar1'
import {EDIT_ROW_COLORS} from '../../../utils/contants'
import InputErrorBox from '../../components/InputErrorBox'
import roleContext from '../../context/roleContext'
import {useAuth} from '../../modules/auth'
import {RoleContextValue} from '../../types/OtherTypes'
import {
  cancelSubmit,
  deleteHoliday,
  getHoliday,
  getHolidayById,
  handleSubmit,
  validateForm,
} from './HolidayFunction'
import {toast} from 'react-toastify'
import {handleInputChange} from '../../CommonFunction'
import { getHolidayDate } from './HolidayFunction'
import { selectFloatingHoliday } from '../../../api/HolidayAPI'
import { getMyFloatingHolidays } from './HolidayFunction'
//Tab
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { getAllFloatingLeaves, removeFloatingHoliday } from '../../../api/HolidayAPI'

const Holiday = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const [holiday, setHoliday] = useState([{id: '', holidayName: '', date: ''}])
  const [editId, setEditId] = useState(null)
  const [inputError, setInputError] = useState<any>({})
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  const {currentUser} = useAuth()
  const isAdminUser = currentUser?.isAdmin || false
  const normalizedRoleName = (roleState.roleName || '').trim().toUpperCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ')
  const canViewFloatingLeaveData = isAdminUser || normalizedRoleName === 'ADMIN' || normalizedRoleName === 'SUPER ADMIN' || normalizedRoleName === 'SUPERADMIN'
  const initialState = {holidayName: '', date: '', isFloating: false,}
  const [inputField, setInputField] = useState(initialState)
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  //Floating Leave Holiday Check Box
  const [selectedFloatingHolidays, setSelectedFloatingHolidays] = useState<string[]>([])
  const [savedFloatingHolidays, setSavedFloatingHolidays] = useState<string[]>([])
  const [floatingLeaveData, setFloatingLeaveData] = useState<any[]>([])

  const deleteFloatingHoliday = async (id: string) => {
    try {
      const res = await removeFloatingHoliday(id)
      if (
        res.statusCode === 200 ||
        res.statusCode === 202
      ) {
        toast.success(res.message)
        getAllFloatingLeaves().then((response: any) => {
          if (response?.data) {
            setFloatingLeaveData(response.data)
          }
        })
      }
    } catch (error) {
      toast.error('Something went wrong')
    }
  }

  useEffect(() => {
    let mounted = true
    if (mounted) {
      //Floating Leave Regarding(Employee apply thne that button disable)
      getMyFloatingHolidays().then((res: any) => {
        if (res?.data) {
          const selectedIds = res.data.map(
            (item: any) => item.holidayId
          )
          setSelectedFloatingHolidays(selectedIds)
          setSavedFloatingHolidays(selectedIds)
        }
      })
      getHoliday(setHoliday, setAPIStatus)
      if (canViewFloatingLeaveData) {
        getAllFloatingLeaves().then((res: any) => {
          if (res?.data) setFloatingLeaveData(res.data)
        })
      }
      setIsAddUserModalOpen(false)
      setIsEditModalOpen(false)
    }
    return () => {
      mounted = false
    }
  }, [canViewFloatingLeaveData])

  // //Floating Leave Regarding(Employee apply thne that button disable)
  // getMyFloatingHolidays().then((res: any) => {
  //   if (res?.data) {
  //     const selectedIds = res.data.map(
  //       (item: any) => item.holidayId
  //     )
  //     setSelectedFloatingHolidays(selectedIds)
  //   }
  // })

  const handleClose = () => {
    setIsAddUserModalOpen(false)
  }

    //Search Bar added
    const [searchTerm, setSearchTerm] = useState('')
    const [floatingSearchTerm, setFloatingSearchTerm] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 10
    const filteredFloatingData = floatingLeaveData.filter((obj: any) => {
      const search = floatingSearchTerm.toLowerCase().trim()
      return (
        obj.user.firstName?.toLowerCase().includes(search) ||
        obj.user.lastName?.toLowerCase().includes(search) ||
        `${obj.user.firstName || ''} ${obj.user.lastName || ''}`.toLowerCase().includes(search) ||
        obj.user.employeeCode?.toLowerCase().includes(search) ||
        obj.holiday.name?.toLowerCase().includes(search)
      )
    })
    useEffect(() => { setCurrentPage(1) }, [floatingSearchTerm])
    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

    const groupedFloatingData = filteredFloatingData.reduce(
      
  (acc: any, obj: any) => {
    const key = obj.user.employeeCode

    if (!acc[key]) {
      acc[key] = {
        employeeName: `${obj.user.firstName} ${obj.user.lastName}`,
        employeeCode: obj.user.employeeCode,
        // selectedDate: obj.createdAt,
        holidays: [],
      }
    }

    acc[key].holidays.push({
      id: obj.id,
      name: obj.holiday.name,
      date: obj.holiday.date,
      selectedDate: obj.createdAt,
    })
    return acc
  },
  {}
)
  const groupedArray = Object.values(groupedFloatingData)
  const paginatedGroupedData = groupedArray.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  )
  const totalPages = Math.ceil(
    groupedArray.length / recordsPerPage
  )
    const filteredHoliday = holiday
      .filter((item: any) =>
      item?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .sort((a: any, b: any) => {
        const dateA = getHolidayDate(a)
        const dateB = getHolidayDate(b)
        if (!dateA || !dateB) return 0
        return dateA.getTime() - dateB.getTime()
      })
  return (
    <>
      <Modal
        show={isAddUserModalOpen}
        onClose={() => setIsAddUserModalOpen(false)}
        animation={false}
        backdrop='static'
        onRequestClose={handleClose}
        centered
      >
        {/* begin::modal header--add holiday */}
        <div className='modal-header'>
          <h2 className='fw-bolder'>Add Holiday</h2>
          
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            style={{cursor: 'pointer'}}
            onClick={() => {
              cancelSubmit(setInputField, initialState, setEditId, setInputError)
              handleClose()
            }}
          >
            <i className='fa-solid fa-xmark fs-1' />
          </div>
        </div>
        <div className='m-3'>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Holiday Name</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='text'
              placeholder='Holiday Name...'
              name='holidayName'
              value={inputField.holidayName}
              onChange={(event) =>
                handleInputChange(event, setInputField, inputError, setInputError)
              }
            />
            {<InputErrorBox Message={inputError.holidayName} />}
          </div>
          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>Date</label>
            <span className='text-danger ms-1 fs-4 fw-bold'>*</span>

            <input
              className='form-control'
              type='date'
              name='date'
              value={inputField.date}
              onChange={(event) =>
                handleInputChange(event, setInputField, inputError, setInputError)
              }
            />
            {<InputErrorBox Message={inputError.date} />}
          </div>

          <div className='fv-row mb-5 col-md-12'>
            <label className='fs-6 fw-semibold mb-2'>
              Floating Holiday
            </label>
            <div className='form-check form-switch'>
              <input className='form-check-input'
              type='checkbox'
              checked={inputField.isFloating}
              onChange={(e) =>
                setInputField({
                  ...inputField,
                  isFloating: e.target.checked,
                })
              }
              />
            </div>
          </div>

          <div className='d-flex flex-wrap justify-content-end align-items-center'>
            <Button
              onClick={() => {
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
                setInputError('')
              }}
              type='button'
              className='btn btn-secondary me-2 btn-sm font-weight-bold'
              style={{marginLeft: '15px'}}
              disabled={SubmitAPIStatus?.loading}
            >
              Clear
            </Button>
            <Button
              loaderPosition='center'
              type='submit'
              className='btn btn-primary btn-sm font-weight-bold h-10'
              loading={SubmitAPIStatus.loading}
              onClick={() => {
                handleSubmit(
                  inputField,
                  getHoliday,
                  setHoliday,
                  setEditId,
                  initialState,
                  setInputField,
                  editId,
                  cancelSubmit,
                  setAPIStatus,
                  setInputError,
                  validateForm,
                  setSubmitAPIStatus,
                  setIsAddUserModalOpen
                )
              }}
            >
              {editId !== null ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </Modal>
      {/* //end of the form */}

      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          {/* begin:: card */}
          <div className='card card-xl-stretch mb-xl-8'>
            {/* begin:: card header */}
            <div className='card-header'>
               <div className='card-title m-0'>Holidays</div>
               <div className='d-flex align-items-center gap-2'>
                <input
                    type="text"
                    className="form-control form-control-sm w-250px"
                    placeholder="Search Holiday..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  
                {/* Begin::Add User button */}
                  <button
                    hidden={!checkRole(['holidays_edit'], roleState.features)}
                    type='button'
                    className='btn btn-sm btn-primary'
                    onClick={() => {
                      setIsAddUserModalOpen(true)
                    }}
                  >
                    Add Holiday
                  </button>
                  <button 
                    className='btn btn-sm btn-success' 
                    disabled={selectedFloatingHolidays.length === 0} 
                    hidden={checkRole(['holidays_edit'], roleState.features)}
                    onClick={() => { 
                      selectFloatingHoliday(selectedFloatingHolidays).then((res: any) => { 
                        if (res.statusCode === 201) { 
                          toast.success(res.message) 
                          // refresh selected floating holidays
                          getMyFloatingHolidays().then((response: any) => {
                            if (response?.data) {
                              const selectedIds = response.data.map(
                                (item: any) => item.holidayId
                              )
                              setSelectedFloatingHolidays(selectedIds)
                              setSavedFloatingHolidays(selectedIds)
                            }
                          })
                        } 
                        else { 
                          toast.error(res.message) 
                        } 
                      }) 
                    }} 
                  > 
                    Save Floating Holiday 
                  </button>

                {/* end::Add user button */}
              </div>
            </div>
            {/* begin:: card body */}
            <div className='card-body'>

              {/* --- Holiday Tab --- */}
              <Tabs defaultActiveKey="holiday" className="mb-3" >
                <Tab eventKey="holiday" title="Holidays">
              {APIStatus.submitLoading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : APIStatus.error != null ? (
                <div className='mb-lg-15 alert alert-danger'>
                  <div className='alert-text font-weight-bold'>{APIStatus.error}</div>
                </div>
              ) : (
                <div className='table-responsive  '>
                  <table
                    className='table 
                    table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='pl-1 text-center text-muted' 
                        style={{minWidth: '80px'}}
                        hidden={checkRole(['holidays_edit'], roleState.features)}
                        >Select</th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 flex-start text-muted' style={{minWidth: '150px'}}>
                          {changeTextCapital('Holiday Name')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '120px'}}>
                          {changeTextCapital('Day')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '120px'}}>
                          {changeTextCapital('Date')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth:'120px'}}>
                          Floating
                        </th>

                        <th
                          className='pl-1 text-center text-muted'
                          hidden={!checkRole(['holidays_edit'], roleState.features)}
                          style={{minWidth: '100px'}}
                        >
                          {changeTextCapital('Actions')}
                        </th>
                      </tr>
                    </thead>
                    {filteredHoliday?.length > 0 ? (
                      <tbody className='text-gray-800 fw-semibold text-left'>
                        {filteredHoliday.map((obj: any, index: number) => (
                          <tr
                            className={`${editId === obj?.id ? `${EDIT_ROW_COLORS} ` : ''}`}
                            key={obj?.id ?? '-'}
                          >
                            {/* <td className='text-center'>{index + 1}</td> */}
                         
                            <td className='text-center'
                            hidden={checkRole(['holidays_edit'], roleState.features)}
                            >
                              {obj?.isFloating &&
                              !checkRole(['holidays_edit'], roleState.features) &&
                              (
                              <input
                                type='checkbox'
                                style={{
                                  width: '16px',
                                  height: '16px',
                                  cursor: 'pointer',
                                }}
                                checked={selectedFloatingHolidays.includes(obj.id)}
                                disabled={
                                  // Already saved floating holiday
                                  savedFloatingHolidays.includes(obj.id)
                                }
                                onClick={() => {
                                  const holidayDate = getHolidayDate(obj)
                                  if (!holidayDate) return
                                  const today = new Date()
                                  holidayDate.setHours(0, 0, 0, 0)
                                  today.setHours(0, 0, 0, 0)

                                  // Previous date notification
                                  if (holidayDate < today) {
                                    toast.error('Floating holiday date expired')
                                    return
                                  }

                                  // More than 2 notification
                                  if (
                                    selectedFloatingHolidays.length >= 2 &&
                                    !selectedFloatingHolidays.includes(obj.id)
                                  ) {
                                    toast.error('You have already selected the maximum of 2 floating holidays allowed')
                                    return
                                  }

                                }}

                                onChange={(e) => {
                                  const holidayDate = getHolidayDate(obj)
                                  if (!holidayDate) return
                                  const today = new Date()
                                  holidayDate.setHours(0, 0, 0, 0)
                                  today.setHours(0, 0, 0, 0)
                                  // Prevent previous date selection
                                  if (holidayDate < today) {
                                    return
                                  }
                                  // Prevent more than 2 selection
                                  if (
                                    e.target.checked &&
                                    selectedFloatingHolidays.length >= 2
                                  ) {
                                    return
                                  }
                                  // Select
                                  if (e.target.checked) {
                                    setSelectedFloatingHolidays([
                                      ...selectedFloatingHolidays,
                                      obj.id,
                                    ])
                                  } else {
                                    // Unselect
                                    setSelectedFloatingHolidays(
                                      selectedFloatingHolidays.filter(
                                        (id) => id !== obj.id
                                      )
                                    )
                                  }
                                }}
                              />
                              )}
                            </td>
                           
                            <td className='text-center'>{index + 1}</td>

                            <td className='flex-start' style={{ minWidth: '100px', }}>{obj?.name ?? '-'}</td>
                            {/* Change the Day Column */}
                            {/* <td className='text-center'>
                              {obj?.date
                                ? new Date(obj.date).toLocaleDateString(undefined, {
                                    weekday: 'long',
                                  })
                                : '-'}
                            </td> */}
                            {/* ----------------------------------------------------------------- */}
                            {/* Year auto-updated and Day auto-calculated using getHolidayDate() */}
                            <td className='text-center'>
                              {obj?.date
                                ? (() => {
                                    const d = getHolidayDate(obj)

                                    if (!d) return '-'

                                    return d.toLocaleDateString(undefined, { weekday: 'long' })
                                  })()
                                : '-'}
                            </td>
                             {/* ----------------------------------------------------------------- */}
                            {/* <td className='text-center'>
                              {obj?.date
                                ? new Date(obj.date)
                                    .toLocaleDateString(undefined, {
                                      day: 'numeric',
                                      month: 'numeric',
                                      year: 'numeric',
                                    })
                                    .replace(/(\d+)\/(\d+)\/(\d+)/, '$2/$1/$3')
                                : '-'}
                            </td> */}
                            {/* ----------------------------------------------------------------- */}
                            {/* Display date in DD/MM/YYYY format with current year */}
                            <td className='text-center'>
                              {obj?.date
                                ? (() => {
                                    const d = getHolidayDate(obj)
                                    if (!d) return '-'
                                    const day = String(d.getDate()).padStart(2, '0')
                                    const month = String(d.getMonth() + 1).padStart(2, '0')
                                    const year = d.getFullYear()
                                    return `${day}/${month}/${year}`
                                  })()
                                : '-'}
                            </td>
                            {/*-------------------------------------------------------------------*/}
                            <td className='text-center'>
                              {obj?.isFloating?(
                                <span className='badge badhe-light-sucess'>
                                  Yes
                                </span>
                              ):(
                                <span className='badge badge-light-danger'>
                                  No
                                </span>
                              )}
                            </td>
                            {/* ----------------------------------------------------------------- */}
                            <td hidden={!checkRole(['holidays_edit'], roleState.features)}>
                              <div className='d-flex justify-content-center flex-shrink-0'>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-info btn-sm me-1'
                                  onClick={() => {
                                    document.getElementById('holidayName')?.focus()
                                    getHolidayById(
                                      obj.id,
                                      inputField,
                                      setInputField,
                                      setEditId,
                                      setInputError
                                    )
                                    setIsEditModalOpen(true)
                                    setIsAddUserModalOpen(true)
                                  }}
                                >
                                  <i className='far fa-edit'></i>
                                </button>
                                <button
                                  className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
                                  onClick={() =>
                                    deleteHoliday(
                                      obj.id,
                                      getHoliday,
                                      setHoliday,
                                      setAPIStatus,
                                      cancelSubmit,
                                      setInputField,
                                      initialState,
                                      setEditId,
                                      setInputError
                                    )
                                  }
                                >
                                  <i className='fa fa-trash'></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={5}>
                            <Center>No Record Available.</Center>
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  
                </div>
              )}
              </Tab>
              
              {/* ---- Floating Tab ---- */}
              {
              canViewFloatingLeaveData && (
              <Tab eventKey="floating"  title="Floating Leave Data">
                <div className='d-flex justify-content-end mb-3'>
                  <input
                    type='search'
                    className='form-control form-control-sm w-250px'
                    placeholder='Search by employee name or employee code'
                    aria-label='Search by employee name or employee code'
                    value={floatingSearchTerm}
                    onChange={(event) => setFloatingSearchTerm(event.target.value)}
                  />
                </div>
                <div className='table-responsive'>
                  <table
                    className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'
                  >
                    <thead>
                      <tr className='fw-bold text-muted'>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>
                          {changeTextCapital('Sr.No')}
                        </th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '60px'}}>Employee Name</th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '60px'}}>Employee Code</th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>Floating Holiday</th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>Holiday Date</th>
                        <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>Action</th> 
                        {/* <th className='pl-1 text-center text-muted' style={{minWidth: '80px'}}>Selected Date</th> */}
                        
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedGroupedData.length > 0 ? (
                        // Object.values(groupedFloatingData).map(
                        paginatedGroupedData.map(
                          (obj: any, index: number) =>
                            obj.holidays.map((holiday: any, holidayIndex: number) => (
                              <tr key={`${index}-${holidayIndex}`}>
                                {holidayIndex === 0 && (
                                  <>
                                    <td
                                      className='text-center'
                                      rowSpan={obj.holidays.length}
                                    >
                                      {(currentPage - 1) * recordsPerPage + index + 1}
                                    </td>

                                    <td
                                      className='text-center'
                                      rowSpan={obj.holidays.length}
                                    >
                                      {obj.employeeName}
                                    </td>

                                    <td
                                      className='text-center'
                                      rowSpan={obj.holidays.length}
                                    >
                                      {obj.employeeCode}
                                    </td>
                                  </>
                                )}

                                <td className='text-center'>
                                  {holiday.name}
                                </td>

                                <td className='text-center'>
                                  {new Date(holiday.date).toLocaleDateString('en-GB')}
                                </td>

                                {/* <td className='text-center'>
                                  <button
                                    className='badge badge-light-danger'
                                    style={{
                                      width: '55px',
                                      height: '32px',
                                      borderRadius: '10px',
                                      fontWeight: '600',
                                      border: 'none',
                                      outline: 'none',
                                      boxShadow: 'none',
                                    }}
                                    onClick={() => {
                                      deleteFloatingHoliday(holiday.id)
                                    }}
                                  >
                                    Remove
                                  </button>
                                </td> */}
                                {/* Previous Date Remove button disable */}
                                <td className='text-center'>
                                  <button
                                    className='badge badge-light-danger'
                                    style={{
                                      width: '55px',
                                      height: '32px',
                                      borderRadius: '10px',
                                      fontWeight: '600',
                                      border: 'none',
                                      outline: 'none',
                                      boxShadow: 'none',
                                      cursor:
                                        new Date(holiday.date) < new Date()
                                          ? 'not-allowed'
                                          : 'pointer',
                                      opacity:
                                        new Date(holiday.date) < new Date()
                                          ? 0.5
                                          : 1,
                                    }}
                                    disabled={new Date(holiday.date) < new Date()}
                                    onClick={() => {
                                      deleteFloatingHoliday(holiday.id)
                                    }}
                                  >
                                    Remove
                                  </button>
                                </td>

                                {/* {holidayIndex === 0 && (
                                  <td
                                    className='text-center'
                                    rowSpan={obj.holidays.length}
                                  >
                                    {new Date(obj.selectedDate).toLocaleDateString(
                                      'en-GB'
                                    )}
                                  </td>
                                )} */}
                              </tr>
                            ))
                        )
                      ) : (
                        <tr>
                          <td colSpan={7}>
                            <Center>
                              No Record Available.
                            </Center>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className='d-flex justify-content-center align-items-center mt-4 gap-3'>
                    <button
                      className='btn btn-sm btn-primary'
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      Previous
                    </button>

                    <span>
                      Page {currentPage} of {totalPages}
                    </span>

                    <button
                      className='btn btn-sm btn-primary'
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </Tab>
              )}
              </Tabs>  
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Holiday
